import { GreenHouseMap, Row } from '../models';

export const greenHouseMapToRowList = (map: GreenHouseMap) =>
    map.centralPathRowSets
        .flatMap((centralPath) => [centralPath.left, centralPath.right])
        .filter((row): row is Row => !!row);
